export const ERROR_TYPE_VALIDATION = 'VALIDATION_ERROR';

export const ERROR_TYPES = [
  ERROR_TYPE_VALIDATION,
];
